module.exports = __webpack_public_path__ + "assets/img/DATA_EXPORT_PLUGIN.760773dd.svg";